import { initCarousel } from './functions';

window.addEventListener('DOMContentLoaded', initializeSplash);

function initializeSplash() {
  const carousels = document.querySelectorAll('.wp-block-dmnp-splash-carousel');

  for (const carousel of carousels) {
    initCarousel(carousel, { autoplay: 4000, hoverpause: true });
  }
}
